var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGetPaidOnlineBusiness = function SvgGetPaidOnlineBusiness(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 18a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17Zm0 1a9.5 9.5 0 1 1 0-19 9.5 9.5 0 0 1 0 19ZM7 11h1a1 1 0 0 0 1 1h1a1 1 0 1 0 0-2H9a2 2 0 1 1 0-4V5h1v1a2 2 0 0 1 2 2h-1a1 1 0 0 0-1-1H9a1 1 0 0 0 0 2h1a2 2 0 1 1 0 4v1H9v-1a2 2 0 0 1-2-2Z",
    fill: "#162D3D"
  })));
};
export default SvgGetPaidOnlineBusiness;